import { render, staticRenderFns } from "./topic-echarts.vue?vue&type=template&id=55d8b803&scoped=true"
import script from "./topic-echarts.vue?vue&type=script&lang=js"
export * from "./topic-echarts.vue?vue&type=script&lang=js"
import style0 from "./topic-echarts.vue?vue&type=style&index=0&id=55d8b803&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d8b803",
  null
  
)

export default component.exports